// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { NgxLoggerLevel } from 'ngx-logger';
import { version } from '../../../../package.json';

export const environment = {
  app_version: version,
  backend: {
    changepassword: '/api/change-password', //NOSONAR
    itinerary: {
      permission: '/api/itinerary/{{itinerary-id}}/permissions'
    },
    login: '/api/login',
    resetpassword: {
      confirm: '/api/reset-password',
      request: '/api/reset-password/send-token'
    }
  },
  googleApiKey: 'AIzaSyCpfLtxFvB80SScElLPv_OkySpXHzECMKQ',
  host: 'http://tmt.dev.eminds.it/',
  // logging
  logging: {
    consoleLogLevel: NgxLoggerLevel.OFF, // OFF, TRACE, DEBUG, INFO, LOG, WARN, ERROR
    serverLogLevel: NgxLoggerLevel.OFF,
    serverUrl: 'http://customeroutput.logstash.eminds.it' // logstash
  },
  // Mail service configuration (RestServiceMail)
  mailService: {
    baseUrl: 'https://tmt.tailormadetour.biz:8448/MailRestService',  // URL del servizio RestServiceMail
    username: 'admin',                                                // Credenziali fisse
    password: 'EmindS2026',                                           // Credenziali fisse
    clientCode: 'EMINDS',                                             // Codice cliente
    endpoints: {
      auth: '/api/auth/login',                                        // Endpoint autenticazione
      send: '/api/emails'                                             // Endpoint invio email
    }
  },
  production: false,
  urlCitiesImages: 'http://188.213.167.6:81/Gastaldi/Backend/Photos/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
